"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ctors = void 0;
var tslib_1 = require("tslib");
var Record_1 = require("fp-ts/Record");
/**
 *  @since 0.0.1
 */
var Ctors = function (tag) { return function (keys) {
    var ctors = Record_1.mapWithIndex(function (key, _) { return function (props) {
        var _a;
        return (tslib_1.__assign(tslib_1.__assign({}, props), (_a = {}, _a[tag] = key, _a)));
    }; })(keys);
    return {
        of: ctors,
        as: ctors,
        make: function (a) { return a; },
        tag: tag
    };
}; };
exports.Ctors = Ctors;
